var exports = {
  "Dw": "creatorLink__NKRxsG",
  "o1": "actions__4PS01U",
  "wx": "header__bcME4s",
  "Qs": "content__onVHOe",
  "H": "avatarContainer__30pK4Y",
  "my": "avatar__CLN1Tg",
  "rm": "creatorInfo__TmYG4V",
  "m1": "timestampArea__caAiuR",
  "NL": "updatedText__67Sp16",
  "N1": "timestampLink__M_I28n",
  "vE": "timestamp__WMaGHD",
};

module.exports = exports;
